const breakpoints = {
  xs: 0,
  sm: 430,
  md: 640,
  lg: 769,
  xl: 1024,
  xxl: 1230,
};

export default breakpoints;

export const MAX_WIDTH = 1230;
